import { createContext } from 'react';
import { UserPreference } from '../models/user-preferences.model';
import { Project } from '@models/project.model';
import { Application } from '@models/application.model';
import { ApplicationVersion } from '@models/application-version.model';
import { UserActivity } from '@models/user-activity.model';
export interface UserPreferenceContextType {
  userPreference: UserPreference | undefined;
  setOrUpdatePreference: (
    userPreference: UserPreference,
    callback: VoidFunction,
  ) => void;
  updatePreferenceContext: (userPreference: UserPreference) => void;
  userProjectIds: number[];
  setUserProjectIds: (ids: number[]) => void;
  fetchVersionToUpdatePreference: (props: {
    versionId: number,
    callback?: (version: ApplicationVersion) => void,
    savePreference?: boolean
  }) => void;
  updateDefaultForProjectId: (props: {
    projectId?: number,
    applicationId?: number,
    callback?: (version: ApplicationVersion) => void,
  }) => void;
  setSelectedProject: (project: Project) => void;
  setSelectedApplication: (application: Application) => void;
  setSelectedVersion: (version: ApplicationVersion) => void;
  availableUsers: UserActivity[];
  availableUsersMap: Map<Number, UserActivity>;
}

export const UserPreferenceContext = createContext<UserPreferenceContextType>({
  userPreference: undefined,
  setOrUpdatePreference: (
    userPreference: UserPreference,
    callback: VoidFunction,
  ) => {},
  updatePreferenceContext: (userPreference: UserPreference) => {},
  userProjectIds: [],
  setUserProjectIds: (ids: number[]) => {},
  fetchVersionToUpdatePreference: (props: {
    versionId: number,
    callback?: (version: ApplicationVersion) => void,
    savePreference?: boolean
  }) => {},
  updateDefaultForProjectId: (props: {
    projectId?: number,
    applicationId?: number,
    callback?: (version: ApplicationVersion) => void,
  }) => {},
  setSelectedProject: (project: Project) => {},
  setSelectedApplication: (application: Application) => {},
  setSelectedVersion: (version: ApplicationVersion) => {},
  availableUsers: [],
  availableUsersMap: new Map(),
});
